import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import AlarmIcon from '../../../../../assets/icons/alarm.svg';
import {getCourseLabel} from '../../../../../utils/entity/course';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, goal, program} = contexts;

  const courseLabel = getCourseLabel(course);

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: 'Your Coach',

    icon: AlarmIcon,
    iconGradient: 'danger',
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:goal_coach_review_reminder.title.individual')
       * t('notifications:goal_coach_review_reminder.title.group')
       * t('notifications:goal_coach_review_expiring.title.individual')
       * t('notifications:goal_coach_review_expiring.title.group')
       */
      i18n.t(
        `notifications:${event.type}.title.${course?.client_id ? 'individual' : 'group'}`,
        {
          clientName: course?.client.name,
          courseDates: courseLabel ? `(${courseLabel})` : '',
          goalTitle: goal?.title,
          programTitle: program?.title,
        },
      ),
  };
};
